import React, { useState } from 'react';
import ImageModal from './ImageModal';

const SpaceGallery = ({ gallery }) => {
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);
  const isModalOpen = selectedPhotoIndex !== null;

  const openModal = (index) => {
    setSelectedPhotoIndex(index);
  };

  const closeModal = () => {
    setSelectedPhotoIndex(null);
  };

  const navigateToPhoto = (index) => {
    setSelectedPhotoIndex(index);
  };

  return (
    <>
      <div className="space-item gallery-bubble">
        <div className="gallery-header">
          <h2>{gallery.name}</h2>
          <p>{gallery.description}</p>
        </div>

        <div className="gallery-grid">
          {gallery.photos.map((photo, index) => (
            <div
              key={photo.id}
              className="gallery-thumbnail"
              onClick={() => openModal(index)}
            >
              <img
                src={photo.image}
                alt={photo.caption}
                className="gallery-thumbnail-image"
              />
              <div className="gallery-thumbnail-caption">
                {photo.caption}
              </div>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <ImageModal
          photos={gallery.photos}
          currentIndex={selectedPhotoIndex}
          onClose={closeModal}
          onNavigate={navigateToPhoto}
        />
      )}
    </>
  );
};

export default SpaceGallery;
